<template>
  <!-- prettier-ignore -->
  <div
    v-show="showFab"
    class="fab-container"
  >

    <basic-context-menu
      v-model="showFabCard"
      animation-in="slide-from-bottom"
      class="fab__context-menu"
      has-full-width-on-mobile
    >
      <template #trigger>
        <fab-button
          :has-bottom-gap="isWww"
          :is-toggle-active="showFabCard"
          @click="toggleFabCard(false)"
        />
      </template>
      <template #content>
        <fab-card
          :entries="entries"
          :show-card="showFabCard"
          @close="toggleFabCard"
        />
      </template>
    </basic-context-menu>
  </div>
</template>

<script setup>
  import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
  import { useRoute } from 'vue-router'

  import { events$ } from '@shared/services'

  import basketStore from '@shared/store/basket'
  import partnerStore from '@shared/store/partner'
  import useApplication from '@shared/hooks/useApplication'
  import useChat from '@shared/hooks/useChat'

  import FabButton from '@shared/components/Fab/FabButton'
  import FabCard from '@shared/components/Fab/FabCard'
  import { fabEntries } from '@shared/components/Fab/entries'

  import { BasicContextMenu } from '@shared/components/Basic'

  import { COLLECTIVE_CHANNEL } from '@shared/config/constants'
  import { EVENT_FAB, CUSTOM_EVENT_CHAT } from '@shared/config/events'

  // HOOKS
  const { isWww } = useApplication()
  const { initChat } = useChat()

  // INIT
  let route
  if (!isWww.value) {
    route = useRoute()
  }
  initChat()

  // DATA
  const showFab = ref(true)
  const showFabCard = ref(false)

  // COMPUTED
  const entries = computed(() => {
    const hideAide =
      route?.meta?.aide ||
      partnerStore.partner.collectiveContractConfig?.channel === COLLECTIVE_CHANNEL.SCPC || // if it's COLLECTIVE // @TODO might be same as partnerStore.isCollective.value?
      partnerStore.isBroker.value ||
      partnerStore.isMobileDistributor.value // if it's a broker/distributor (like privateassekuranz)
    return fabEntries(isWww.value, hideAide, basketStore.basket.existingCustomer)
  })

  // METHODS
  function displayFab() {
    showFab.value = true
  }

  function hideFab() {
    showFab.value = false
  }

  function toggleFabCard() {
    showFabCard.value = !showFabCard.value

    if (showFabCard.value) {
      events$.emit(EVENT_FAB.OPENED)
    }
  }

  // LIFECYCLE HOOKS
  onMounted(() => {
    window.addEventListener(CUSTOM_EVENT_CHAT.CONVERSATION_STARTED, hideFab)
    window.addEventListener(CUSTOM_EVENT_CHAT.CLOSE, displayFab)

    events$.on(EVENT_FAB.OPEN, () => {
      if (!showFabCard.value) toggleFabCard()
    })
  })
  onBeforeUnmount(() => {
    window.removeEventListener(CUSTOM_EVENT_CHAT.CONVERSATION_STARTED, hideFab)
    window.removeEventListener(CUSTOM_EVENT_CHAT.CLOSE, displayFab)
  })
</script>

<style scoped>
.fab-container {
  .fab__context-menu {
    z-index: var(--dvp-stack-level-popup-menu);
  }

  .fab__context-menu:deep(.menu) {
    padding: var(--dotcom-responsive-gutter-responsive) 0;
  }
}

@media (--v-medium) {
  .fab-container {
    .fab__context-menu:deep(.menu) {
      position: fixed;
      right: 24px; /* same as trigger-button */
      bottom: 118px; /* trigger-button-bottom + trigger-button-height + 44px */
      top: initial;
      padding: var(--fixed-spacing-fix-06) 0 var(--fixed-spacing-fix-10);
      width: 396px;
    }
  }
}
</style>
